





































































































































































import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import GeneralModule from '@/store/modules/General';
import LanguageButton from '@/components/LanguageButton.vue';
import MobileButton from '@/components/MobileButton.vue';
import VueRecaptcha from 'vue-recaptcha';

@Component({
  components: {
    LanguageButton,
    MobileButton,
    VueRecaptcha,
  },
})
export default class Login extends Vue {
  username = '';

  password = '';

  AuthInstance = getModule(AuthModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  enableSubmit = true;

  created() {
    if (navigator.language.split('-')[0] === 'th') this.$i18n.locale = 'th';
    else this.$i18n.locale = 'en';
  }

  isGen = false;

  comPair = false;

  isCompair = false;

  genSubPassword: any;

  subPassword = '';

  confirmSubpassword = '';

  isSubpass = true;

  gen2Pass() {
    const twoPass = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    const genPass = twoPass.sort(() => Math.random() - 0.5);
    this.genSubPassword = genPass;
    this.genSubPassword.splice(9, 0, 'Clear');
    this.genSubPassword.push('Del');
  }

  async onSubmit() {
    const { username, password } = this;
    this.GeneralInstance.toggleLoading(true);
    const auth = await this.AuthInstance.Login({
      username,
      password,
    });
    this.GeneralInstance.toggleLoading(false);
    if (auth.data) {
      if (auth.data.token) {
        this.$router.push('/dashboard');
      } else {
        this.GeneralInstance.ShowAlert({
          isAlert: true,
          alertMsg: auth,
          alertColor: 'danger',
        });
      }
    } else {
      if (auth.code) {
        this.GeneralInstance.ShowAlert({
          isAlert: true,
          alertMsg: auth.message,
          alertColor: 'danger',
        });
      } else {
        this.isGen = true;
        this.gen2Pass();
        this.isSubpass = await this.AuthInstance.check2Pass({ username: this.username });
      }
    }
  }

  // onVerify(response) {
  //   if (response) this.enableSubmit = true;
  // }

  // onExpired() {
  //   this.enableSubmit = false;
  // }

  back2Pass() {
    this.username = '';
    this.password = '';
    this.isGen = false;
    this.subPassword = '';
    this.confirmSubpassword = '';
    this.comPair = false;
  }

  async create2Pass(params) {
    const status = await this.AuthInstance.create2Pass(params);
    if (status.code === 0) {
      this.isSubpass = await this.AuthInstance.check2Pass({ username: this.username });
      this.subPassword = '';
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: status.message,
        alertColor: 'success',
      });
    } else {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: status.message,
        alertColor: 'danger',
      });
    }
  }

  async verify2Pass(params) {
    const status = await this.AuthInstance.verify2Pass(params);
    if (status.code === 0) {
      this.$router.push('/dashboard');
    } else {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: 'Secure Code is not correct, try again.',
        alertColor: 'danger',
      });
      this.subPassword = '';
      this.confirmSubpassword = '';
    }
  }

  inputSubPassword(item) {
    if (item === 'Clear') {
      this.subPassword = '';
      this.gen2Pass();
    } else if (item === 'Del') {
      this.subPassword = this.subPassword.slice(0, -1);
      this.gen2Pass();
    } else {
      if (this.subPassword.length < 6) {
        this.subPassword += item;
        this.gen2Pass();
      } else {
        return false;
      }
    }
  }

  compairSubPassword(item) {
    if (item === 'Clear') {
      this.confirmSubpassword = '';
      this.gen2Pass();
    } else if (item === 'Del') {
      this.confirmSubpassword = this.confirmSubpassword.slice(0, -1);
      this.gen2Pass();
    } else {
      if (this.confirmSubpassword.length < 6) {
        this.confirmSubpassword += item;
        this.gen2Pass();
      } else {
        return false;
      }
    }
  }

  compairSubpass() {
    if (this.subPassword.length === 6) {
      this.comPair = true;
    } else {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: 'กรุณาใส่ Secret Code 6 หลัก',
        alertColor: 'danger',
      });
    }
  }

  compair() {
    if (this.confirmSubpassword.length === 6) {
      if (this.subPassword === this.confirmSubpassword) {
        this.confirmSubPass();
      } else {
        this.comPair = false;
        this.subPassword = '';
        this.confirmSubpassword = '';
        this.GeneralInstance.ShowAlert({
          isAlert: true,
          alertMsg: 'Password not match',
          alertColor: 'danger',
        });
      }
    } else {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: 'กรุณาใส่ Secret Code 6 หลักเพื่อยืนยันอีกครั้ง',
        alertColor: 'danger',
      });
    }
  }

  confirmSubPass() {
    if (this.subPassword.length === 6) {
      const params = {
        username: this.username,
        password: this.password,
        subPassword: this.subPassword,
      };
      this.comPair = false;
      if (this.isSubpass === true) {
        this.verify2Pass(params);
      } else {
        this.create2Pass(params);
      }
    } else {
      this.subPassword = '';
      this.confirmSubpassword = '';
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: 'Please Fill 6 code sub password !',
        alertColor: 'danger',
      });
    }
  }
}
